import { PageTitle } from '@procureai/ui-mui';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export const IntakeDetailPageTitle = () => {
  const { t } = useTranslation(I18nNamespace.intake);

  const title = t('IntakeDetail.title');

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageTitle title={title} />
    </>
  );
};
